// We keep the legacy size values for now to avoid too many breaking changes in v5 of the package. We'll likely
// create a codemod later so that clients can migrate with ease.
// TODO: remove this type once all clients have migrated to the new color values
export const buttonSizeLegacy = ['micro', 'regular', 'jumbo'] as const;

export const buttonWithoutTextSize = ['small', 'default', 'large', 'xlarge', 'xxlarge'] as const;
export const buttonWithTextSize = ['small', 'default', 'large'] as const;
